module.exports = __webpack_public_path__ + "static/img/produto_p.ec2aa5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/refricola/produto_p.png
// module id = TOPB
// module chunks = 0